import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  emoji: '⚽',
  label: 'Paso 1',
  title: 'Selecciona el encuentro',
  desc: 'Argentina vs Francia, Brasil vs España o cualquier partido del Mundial.',
  color: 'text-brand-blue',
  border: 'border-brand-blue/30',
  glow: 'bg-brand-blue/10'
}, {
  emoji: '🧠',
  label: 'Paso 2',
  title: 'VisionPro procesa miles de datos',
  desc: 'Forma reciente, enfrentamientos históricos, estadísticas y contexto del partido.',
  color: 'text-brand-green',
  border: 'border-brand-green/30',
  glow: 'bg-brand-green/10'
}, {
  emoji: '📊',
  label: 'Paso 3',
  title: 'Recibe un análisis completo',
  desc: 'Probabilidades, marcador estimado y tendencias clave.',
  color: 'text-brand-gold',
  border: 'border-brand-gold/30',
  glow: 'bg-brand-gold/10'
}];
export function HowItWorks() {
  return <section className="py-12 md:py-16 px-4 relative" data-id="element-114">
      <div className="max-w-5xl mx-auto" data-id="element-115">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-116">
          <div className="text-xs font-mono uppercase tracking-[0.3em] text-brand-blue mb-4" data-id="element-117">
            // ¿CÓMO FUNCIONA?
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold leading-tight" data-id="element-118">
            Tres pasos para analizar <br className="hidden md:block" data-id="element-119" />
            <span className="text-brand-green" data-id="element-120">cualquier partido.</span>
          </h2>
        </motion.div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-4 md:gap-6 relative" data-id="element-121">
          {/* Connecting line on desktop */}
          <div className="hidden md:block absolute top-[44px] left-[16%] right-[16%] h-px bg-gradient-to-r from-brand-blue/30 via-brand-green/30 to-brand-gold/30 pointer-events-none" data-id="element-122" />

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-123">
              {/* Emoji badge */}
              <div className={`relative w-20 h-20 mb-5 rounded-2xl glass-card flex items-center justify-center ${step.border}`} data-id="element-124">
                <div className={`absolute inset-0 ${step.glow} blur-[24px] rounded-2xl`} data-id="element-125" />
                <span className="text-4xl relative z-10" role="img" aria-label={step.title} data-id="element-126">
                  {step.emoji}
                </span>
              </div>

              <div className={`text-xs font-mono uppercase tracking-[0.2em] mb-2 ${step.color}`} data-id="element-127">
                {step.label}
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold text-white mb-3" data-id="element-128">
                {step.title}
              </h3>
              <p className="text-sm md:text-base text-gray-400 leading-relaxed max-w-xs" data-id="element-129">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}